module.exports = __webpack_public_path__ + "/login_ui/img/cl-d49e530373c92a9fba4f238570df050f.svg";